import React from "react";
 
const Modal = ({ isOpen, onClose, children }) => {

    if (!isOpen) return null;
 
    return (
        <>
        <div onClick={onClose} className="modal fade show"  tabindex="-1" aria-labelledby="exampleModalLiveLabel" style={{display: 'block'}} aria-modal="true" role="dialog">
        <div  className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
              {children}
            </div>
        </div>
        </div>
        <div className="modal-backdrop fade show"></div>
        </>
    );
};
 
export default Modal;